export const kijs = 'LEFIZ';
export const resolutions = [
    156543.03392800014,
    78271.516963999937,
    39135.758482000092,
    19567.879240999919,
    9783.9396204999593,
    4891.9698102499797,
    2445.9849051249898,
    1222.9924525624949,
    611.49622628137968,
    305.74811314055756,
    152.87405657041106,
    76.437028285073239,
    38.21851414253662,
    19.10925707126831,
    9.5546285356341549,
    4.7773142679493699,
    2.3886571339746849,
    1.1943285668550503,
    0.59716428355981721,
    0.29858214164761665
];


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/config.js